<template>
  <store-recherche-provider
    :key="constantes.storeName"
    :name="constantes.storeName"
    :copy="constantes.store"
    :isTemporary="true">
    <step-impression-provider
      :commande="commande"
      :nameStore="constantes.storeName" />
  </store-recherche-provider>
</template>

<script>
import StoreRechercheProvider from '@/components/general/store/storeRechercheProvider';
import StepImpressionProvider from '@/components/commande/logistiqueImpression/stepImpression/stepImpressionProvider';
import besoinStore from '@/store/modules/bodac/besoin/besoin';

const STORE_NAME = 'besoinCommande';

export default {
  name: 'StepImpression',
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  components: {
    StoreRechercheProvider,
    StepImpressionProvider,
  },
  data() {
    return {
      constantes: {
        store: besoinStore,
        storeName: STORE_NAME,
      },
    };
  },
};

</script>
